import { render } from "./ServicesSheetQuoteComponent.vue?vue&type=template&id=168404f8&scoped=true"
import script from "./ServicesSheetQuoteComponent.vue?vue&type=script&lang=js"
export * from "./ServicesSheetQuoteComponent.vue?vue&type=script&lang=js"

import "./ServicesSheetQuoteComponent.vue?vue&type=style&index=0&id=168404f8&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168404f8"]])

export default __exports__